import gql from 'graphql-tag';

export default gql`
  mutation registerUserMutation(
    $courses: [CoursesDataInputTC]
    $company: MongoID
    $email: String
    $role: String!
    $dbId: String
    $age: Int
    $manager: MongoID
    $firstName: String
    $lastName: String
    $phone: String
    $login: String
    $password: String
    $isEmailVerificationEnabled: Boolean
  ) {
    registerUserMutation(
      courses: $courses
      company: $company
      email: $email
      role: $role
      dbId: $dbId
      age: $age
      manager: $manager
      firstName: $firstName
      lastName: $lastName
      phone: $phone
      login: $login
      password: $password
      isEmailVerificationEnabled: $isEmailVerificationEnabled
    ) {
      title
      message
    }
  }
`;
